import React from 'react';
import Map from './components/Map';
import Dashboard from './components/Dashboard';

const App = () => (
  <div className="App">
    <Dashboard />
    <Map />
  </div>
);

export default App;
